import * as React from "react";
import * as ReactDOM from "react-dom";

export interface BadgeProps {
  title: string;
  textColor: string;
  backColor: string;
  extraClasses?: string;
  displayContainer?: Element;
}

const hexRegEx = /^#[a-f0-9]{6}$/i;
const isValidHex = (hexColor: string) => hexRegEx.test(hexColor);
const Badge = (props: BadgeProps) => {
    const { displayContainer, extraClasses, title, textColor, backColor } = props;
    const badgeStyle = {
        color: textColor,
        backgroundColor: backColor
    };
    const isTextSet = title !== "";
    const showBadge = isTextSet && isValidHex(textColor) && isValidHex(backColor);
    if (displayContainer) {
        return (
            <>
            {showBadge &&
                ReactDOM.createPortal(
                <div className={ `product__badge ${extraClasses}`} style={badgeStyle}>
                    {title}
                </div>,
                    displayContainer
                )}
            </>
        );
    } else {
        return (
            <>
                { showBadge &&
                    <div className={ `product__badge ${extraClasses}`} style={badgeStyle}>
                        {title}
                    </div>
                }
            </>
        );
    }
};

export default Badge;
